<template>
  <div class="px-6 py-12 text-ontick-carbon-900 dark:text-gray-300">
    <div class="absolute inset-0" v-if="loading">
      <div class="flex h-full w-full items-center justify-center">
        <i v-html="$icons.spinner_lg" class="animate-spin"></i>
      </div>
    </div>
    <template v-else>
      <success-component v-if="success" :product="product" />
      <error-component v-else />
    </template>
  </div>
</template>

<script>
import ErrorComponent from "../components/confirmation/error.component.vue";
import SuccessComponent from "../components/confirmation/success.component.vue";
import { mapActions } from "vuex";

export default {
  components: {
    SuccessComponent,
    ErrorComponent,
  },

  data() {
    return {
      loading: true,
      success: false,
      product: {
        type: null,
        name: null,
        days: null,
        price: null,
        id: null,
        developer: null,
      },
    };
  },

  methods: {
    ...mapActions({
      setUserConfig: "config/setUserConfig",
      fetchAccounts: "accountTypes/fetchAccounts",
    }),
    getConfig() {
      return new Promise((resolve, reject) => {
        this.$api
          .get(this.$endpoint.USER_CONFIGS)
          .then((response) => {
            this.setUserConfig(response.data);
            this.fetchAccounts(response.data.accounts);
            resolve();
          })
          .catch((error) => {
            if (error.data.status == "error") {
              this.setUserConfig(error.data);
            }
            reject();
          });
      });
    },
    confirmInvoice() {
      this.$api
        .post(this.$endpoint.CONFIRM_INVOICE, {
          transaction_uuid: this.$route.params.transaction_id,
        })
        .then((res) => {
          // console.log(res.data);
          const data = res.data;
          if (data.transaction_status === "PAID") {
            this.product = {
              type: data.transaction_type,
              name: data.plan_name || data.extension_name || data.product_name,
              days: data.plan_days || data.extension_days || data.product_days,
              price: data.transaction_value,
              id: data.transaction_id,
              developer: data.product_owner,
            };
            this.getConfig();
            this.success = true;
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  created() {
    this.confirmInvoice();
  },
};
</script>
